import { buildApiUrl, toMockErrorResponse } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'

const normalizeAffiliateList = (responseData) => {
    if (Array.isArray(responseData)) return responseData;
    if (Array.isArray(responseData?.data)) return responseData.data;
    return null;
};


const getAllAffiliateUser = async ()=>{
    const response = await axios.get(buildApiUrl('affiliate/getAllAffiliate/'));

    const AllAffiliateUser = normalizeAffiliateList(response.data);

    console.log('Сервер вернул данные по Affiliate ---- ',response.data);


    return AllAffiliateUser;
};


const setActiveAffiliate = async (id,val)=>{
    const response = await axios.post(buildApiUrl('affiliate/setAffiliateActive/'),{
        id,
        val
    });

    const AllAffiliateUser = normalizeAffiliateList(response.data);

    // console.log('Сервер вернул данные по обновлению статуса Affiliate  - ',response);


    return AllAffiliateUser;
};



const setDeletedAffiliate = async (id,val)=>{
    const response = await axios.post(buildApiUrl('affiliate/setAffiliateDeleted/'),{
        id,
        val
    });

    const AllAffiliateUser = normalizeAffiliateList(response.data);

    // console.log('Сервер вернул данные по обновлению статуса Affiliate  - ',response);


    return AllAffiliateUser;
};




const setUpdateAffiliate = async (dataAffiliateUpdate)=>{
    const response = await axios.post(buildApiUrl('affiliate/setAffiliateUpdate/'),{
        dataAffiliateUpdate
    });

    const AllAffiliateUser = normalizeAffiliateList(response.data);

    //console.log('Сервер вернул данные по обновлению статуса Affiliate  - ',dataAffiliateUpdate,response);


    return AllAffiliateUser;
};


const setSaveNewAffiliate = async (dataAffiliateUpdate)=>{
    const response = await axios.post(buildApiUrl('affiliate/setSaveNewAffiliate/'),{
        dataAffiliateUpdate
    });
    const payload = response.data;
    if (payload?.error || payload?.__error || payload?.result === 'error') {
        return [422, payload];
    }
    const AllAffiliateUser = normalizeAffiliateList(payload);
    if (!AllAffiliateUser) {
        return [502, { errorInfo: 'Сервер не подтвердил создание филиала. Обновите список перед повторной попыткой.' }];
    }

    //console.log('Сервер вернул данные по обновлению статуса Affiliate  - ',response, dataAffiliateUpdate);


    return [200, AllAffiliateUser];
};

Mock.onGet('/api/affiliate/getAllAffiliate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllAffiliateUser = await getAllAffiliateUser();
    // console.log('С сервера пришло - ', AllAffiliateUser);

    // if (!AllAffiliateUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllAffiliateUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllAffiliateUser,
    ]


})


Mock.onPost('/api/affiliate/setActiveAffiliate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllAffiliateUser = await setActiveAffiliate(id,val);

    // if (!AllAffiliateUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllAffiliateUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllAffiliateUser,
    ]


})

Mock.onPost('/api/affiliate/setDeletedAffiliate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllAffiliateUser = await setDeletedAffiliate(id,val);

    // if (!AllAffiliateUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllAffiliateUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllAffiliateUser,
    ]


})


Mock.onPost('/api/affiliate/setUpdateAffiliate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataAffiliateUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Affiliate = await setUpdateAffiliate(dataAffiliateUpdate);

    // console.log('Серовер вернул данные ',AllAffiliateUser);

    // if (!Affiliate) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Affiliate) {
        return [500, { message: 'Ошибка обновления филиала' }]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Affiliate,
    ]


})


Mock.onPost('/api/affiliate/setSaveNewAffiliate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataAffiliateUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    try {
        return await setSaveNewAffiliate(dataAffiliateUpdate);
    } catch (error) {
        return toMockErrorResponse(error, 'Не удалось сохранить филиал');
    }

    // console.log('Серовер вернул данные ',AllAffiliateUser);

    // if (!Affiliate) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    // const accessToken = user.accessToken;

})
